import { render, staticRenderFns } from "./EditNotes.vue?vue&type=template&id=2de90724&scoped=true&"
import script from "./EditNotes.vue?vue&type=script&lang=js&"
export * from "./EditNotes.vue?vue&type=script&lang=js&"
import style0 from "./EditNotes.vue?vue&type=style&index=0&id=2de90724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de90724",
  null
  
)

export default component.exports